export default __webpack_public_path__ + "static/media/Catmint Cartel.12f01187.gif";